<div class="card card-custom gutter-b">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label text-black dark:text-white">
        <ng-icon name="heroClock" class="text-primary mr-2"></ng-icon>
        Deleted Transactions
        <small class="text-primary mr-2">Restore previously deleted transactions</small>
      </h3>
    </div>
    <div class="flex items-center gap-3 card-toolbar">
      <!-- Kept outside the grid toolbar: the navigable grid blocks focus on inputs inside it. -->
      <div class="relative w-[300px] max-w-full">
        <ng-icon
          name="heroMagnifyingGlass"
          class="absolute text-gray-400 -translate-y-1/2 pointer-events-none left-3 top-1/2"
        ></ng-icon>
        <input
          type="search"
          class="w-full py-2 pr-3 text-sm text-gray-900 bg-white border border-gray-300 rounded-md shadow-sm pl-9 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:!bg-gray-800 dark:!border-gray-600 dark:!text-white dark:placeholder:text-gray-400"
          placeholder="Search all columns..."
          aria-label="Search all columns"
          (input)="onFilterChange($event)"
        >
      </div>
      <button
        type="button" 
        class="btn btn-light-primary btn-sm"
        (click)="refreshData()"
        title="Refresh data">
        <ng-icon name="heroArrowPath"></ng-icon> Refresh
      </button>
    </div>
  </div>
  <div class="card-body" #gridContainer>
    <kendo-grid
      [style.height.px]="gridHeight"
      [kendoGridBinding]="transactions"
      [pageable]="true"
      [pageSize]="30"
      [sortable]="true"
      [filterable]="'menu'"
      [navigable]="true"
      class="transaction-grid"
    >
      <ng-template kendoGridToolbarTemplate>
        <button
          type="button"
          class="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
          kendoGridToolbarFocusable
          kendoGridExcelCommand
        >
          <ng-icon name="heroDocument" class="mr-1"></ng-icon> Export to Excel
        </button>
      </ng-template>
      <kendo-grid-column
        [width]="150"
        field="blotterId"
        title="ID"
        [filterable]="false"
      ></kendo-grid-column>
      <kendo-grid-column
        width="100"
        field="repName"
        title="Rep Name"
      ></kendo-grid-column>
      <kendo-grid-column
        width="130"
        field="clientName"
        title="Client Name"
      ></kendo-grid-column>
      <kendo-grid-column width="130" field="accountName" title="Account">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div
            class="selectable text-primary"
            title="View/Edit Account"
            (click)="viewClientInfo(dataItem.clientId)"
          >
            {{ dataItem.accountName }}
          </div>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column
        width="90"
        field="productTypeDesc"
        title="Product"
        [filterable]="false"
      ></kendo-grid-column>
      <kendo-grid-column
        width="90"
        field="sponsorName"
        title="Sponsor"
        [filterable]="false"
      ></kendo-grid-column>
      <kendo-grid-column
        field="productName"
        title="Product Name"
        [filterable]="true"
        [width]="120"
      ></kendo-grid-column>
      <kendo-grid-column
        width="100"
        field="transactionTypeDesc"
        title="Trans Type"
        [filterable]="false"
      ></kendo-grid-column>
      <kendo-grid-column
        width="90"
        field="amount"
        title="Amount"
        [format]="{ style: 'currency', currency: 'USD' }"
        [filterable]="false"
      ></kendo-grid-column>
      <kendo-grid-column
        width="125"
        field="dateDeleted"
        title="Date Deleted"
        [filterable]="false"
      >
        <ng-template kendoGridCellTemplate let-column>
          {{ column.dateDeleted | date : 'MM/dd/yyyy' }}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column
        width="90"
        field="statusTypeDesc"
        title="Status"
        [filterable]="false"
      ></kendo-grid-column>
      <kendo-grid-command-column title="Restore" width="40">
        <ng-template kendoGridCellTemplate let-dataItem>
          <button
            class="btn btn-icon btn-sm btn-light-warning"
            title="Restore Transaction"
            (click)="restoreTransaction(dataItem.blotterId)"
          >
            <ng-icon name="heroBackward"></ng-icon>
          </button>
        </ng-template>
      </kendo-grid-command-column>
      <kendo-grid-excel fileName="Deleted_Transactions.xlsx"></kendo-grid-excel>
    </kendo-grid>
  </div>
  <div class="card-footer d-flex justify-content-between" #cardFooter>
    <div>
      <span class="text-muted">Total transactions: {{ transactions?.length || 0 }}</span>
    </div>
    <div>
      <small class="text-muted">Last updated: {{ lastUpdated | date:'medium' }}</small>
    </div>
  </div>
</div>
